<template>
	<div class="channel-stock">

		<border-view>
			<div class="view-search">
				<FromComm :FromArr="FromArr" />
				<CommonBtngroup class="btngroup" :qhide="false" @select="handSearch('')" @reset="handReset('')" />
			</div>
			<div class="view-row">
				<div style="flex:1">
					<!--金额展示部分-->
					<div class="view-amount">
						<div class="amount-label">
							平台库存总额
						</div>
						<div class="amount-value">
							{{dataInfo?dataInfo.TotalStockCostString:0}}
						</div>
						<div class="amount-unit">
							单位:GTS
						</div>
					</div>
					<!-- 图表 -->
					<stock-rose v-if="dataInfo" :info="dataInfo.StockList" />
				</div>

				<div style="flex:1;margin-left: 12px;">
					<!--金额展示部分-->
					<div class="view-amount">
						<div class="amount-label">
							经销商库存总额
						</div>
						<div class="amount-value">
							{{dataInfo2?dataInfo2.TotalStockCostString:0}}
						</div>
						<div class="amount-unit">
							单位:GTS
						</div>
					</div>
					<!-- 图表 -->
					<stock-rose type="1" v-if="dataInfo2" :info="dataInfo2.StockList" />
				</div>
			</div>
		</border-view>

		<border-view>
			<div class="view-search"
				:style="{height:'auto',display:tableData2&&tableData2.length?'flex':'block',alignItems: 'flex-start'}">
				<div class="row-item" :style="{width:tableData2&&tableData2.length?'1000px':'auto'}">
					<info-table title="平台库存" :titles="headerData" :datas="tableData" @more="getStockPivotTableDetail" />
					<div class="pagination">
						<Pagination ref="invPagination" type='allColor' :pageSize="query2.pageSize" :total="total"
							@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" />

					</div>
				</div>
				<div class="row-item" :style="{width:tableData2&&tableData2.length?'400px':'auto',marginRight:'24px'}"
					v-if="tableData2&&tableData2.length">
					<info-table style="padding-top: 75px;" :titles="headerData2" :datas="tableData2" />
				</div>
			</div>
		</border-view>

		<border-view>
			<div class="view-search"
				:style="{height:'auto',display:tableData5&&tableData5.length?'flex':'block',alignItems: 'flex-start'}">
				<div class="row-item" :style="{width:tableData5&&tableData5.length?'1000px':'auto'}">
					<info-table title="新模式平台库存" :titles="headerData4" :datas="tableData4"
						@more="getOrgConsignmentStockDetail" />
					<div class="pagination">
						<Pagination ref="invPagination" type='allColor' :pageSize="query4.pageSize" :total="total4"
							@handleCurrentChange="handleCurrentChange4" @handleSizeChange="handleSizeChange4" />

					</div>
				</div>
				<div class="row-item" :style="{width:tableData5&&tableData5.length?'400px':'auto',marginRight:'24px'}"
					v-if="tableData5&&tableData5.length">
					<info-table style="padding-top: 75px;" :titles="headerData5" :datas="tableData5" />
				</div>
			</div>
		</border-view>

		<!--新增-->
		<border-view>
			<div class="view-search" style="height:auto;">
				<div class="row-item" style="width:100%;">
					<info-table :titles="headerData3" :datas="tableData3" height="auto" />
				</div>
			</div>
		</border-view>

		<border-view title="历史趋势图">
			<div class="view-search" style="padding-top: 24px;">
				<FromComm :FromArr="FromArr2" />
				<CommonBtngroup class="btngroup" style="min-width:180px;" :qhide="false" @select="handSearch('2')"
					@reset="handReset('2')" />
			</div>
			<div class="view-switch-list">
				<div class="view-switch" style="margin-right:48px;">
					<div class="switch-item-red" v-for="(item,index) in switchYeItems" :key="index"
						:class="[yearIndex===index?'current-red':'']" @click="switchChange(index,'year')">
						{{item}}
					</div>
				</div>
				<div class="view-switch">
					<div class="switch-item-blue" v-for="(item,index) in switchSJItems" :key="index"
						:class="[sjIndex===index?'current-blue':'']" @click="switchChange(index,'sj')">
						{{item}}
					</div>
				</div>
			</div>
			<!-- 图表 -->
			<company-history :info="dataInfo3" :type="yearIndex" />
		</border-view>
	</div>
</template>

<script>
	import {
		GetHelperLevel1,
		GetHelperLevel3,
		GetWMSReportStockForOrganization,
		GetWMSReportStockForCustomer,
		GetStockPivotTable,
		GetStockPivotTableDetail,
		GetWMSReportCustomerStockTendency,
		GetOrgConsignmentStock,
		GetOrgConsignmentStockDetail
	} from '@/api/newsapi'

	import {
		StockPivotTableByCost
	} from '@/api/home'



	import FromComm from '../../../views/home/components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../components/commongroup.vue'
	import stockRose from './charts/stock-rose.vue';
	import infoTable from './charts/info-table.vue';
	import companyHistory from './charts/company-history.vue';
	import Pagination from '../../../../components/pagination.vue'
	import borderView from './border-view.vue';
	import {
		FromArr,
		FromArr2
	} from '../FormData/channelStock';
	export default {
		components: {
			stockRose,
			FromComm,
			CommonBtngroup,
			infoTable,
			Pagination,
			companyHistory,
			borderView
		},
		data() {
			return {
				FromArr: [],
				FromArr2: [],
				switchYeItems: ['月度', '季度', '年度'],
				yearIndex: 1,
				switchSJItems: ['平台', '经销商'],
				sjIndex: 0,
				query: {},
				dataInfo: null,
				query2: {
					CusGrade: 1,
					pageSize: 10,
					pageIndex: 1,
				},
				total: 0,
				dataInfo2: null,
				query3: {},
				dataInfo3: null,
				headerData: [{
					"label": '产品分类',
					"key": 'LEVEL3',
					"width": "120px"
				}, {
					"label": '经销商名称',
					"key": 'CusName',
					"width": "flex"
				}, {
					"label": '数量',
					"key": 'Quantity',
					"width": "80px"
				}, {
					"label": '库存天数',
					"key": 'StockDayCount',
					"width": "100px"
				}, {
					"label": '操作',
					"key": 'button',
					"width": "40px"
				}],
				tableData: [],
				headerData2: [{
					width: 'flex',
					label: '产品型号',
					key: 'InvAddCode'
				}, {
					width: '80px',
					label: '库存数量',
					key: 'Quantity'
				}, {
					width: "80px",
					label: '库存天数',
					key: 'StockDayCount',
				}],
				tableData2: [],
				headerData3: [{
					"label": '平台商',
					"key": 'CusName',
					"width": "flex"
				}, {
					"label": '产品线',
					"key": 'InvClassName',
					"width": "flex"
				}, {
					"label": '库存金额（元）',
					"key": 'StockCostString',
					"width": "flex"
				}, {
					"label": '库存天数（天）',
					"key": 'StockDayCount',
					"width": "flex"
				}],
				tableData3: [],
				query4: {
					PageIndex: 1,
					PageSize: 10,
				},
				total4: 0,
				headerData4: [{
					"label": '产品',
					"key": 'InvName',
					"width": "150px"
				}, {
					"label": '平台',
					"key": 'CompanyName',
					"width": "flex"
				}, {
					"label": '寄售点',
					"key": 'ShowPosCode',
					"width": "flex"
				}, {
					"label": '库存数量',
					"key": 'Quantity',
					"width": "100px"
				}, {
					"label": '操作',
					"key": 'button',
					"width": "40px"
				}],
				tableData4: [],
				headerData5: [{
					"label": '产品型号',
					"key": 'InvAddCode',
					"width": "flex"
				}, {
					"label": '数量',
					"key": 'Quantity',
					"width": "flex"
				}],
				tableData5: [],
			}
		},
		created() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromArr2 = JSON.parse(JSON.stringify(FromArr))
			this.getHelperLevel1();
			this.getHelperLevel3();
			this.getWMSReportStockForOrganization();
			this.getWMSReportStockForCustomer();
			this.getStockPivotTable();
			this.getWMSReportCustomerStockTendency();
			this.getStockPivotTableByCost();
			this.getOrgConsignmentStock();
		},
		methods: {
			//获取l1数据
			async getHelperLevel1() {
				let {
					code,
					data
				} = await GetHelperLevel1({})
				if (code == 0) {
					this.FromArr[0].options = [{
						key: '不限',
						value: '',
					}]
					this.FromArr2[0].options = [{
						key: '不限',
						value: '',
					}]
					data.map((item, index) => {
						let obj = {
							key: item.value,
							value: item.key
						}
						this.FromArr[0].options.push(obj);
						this.FromArr2[0].options.push(obj);
					})
				}
			}, //获取l3数据
			async getHelperLevel3() {
				let {
					code,
					data
				} = await GetHelperLevel3({});

				if (code == 0) {
					this.FromArr[1].options = [];
					this.FromArr2[1].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.value,
							value: item.key
						}
						this.FromArr[1].options.push(obj);
						this.FromArr2[1].options.push(obj);
					})
				}
			},
			// 平台库存 
			async getWMSReportStockForOrganization() {
				let {
					code,
					data
				} = await GetWMSReportStockForOrganization(this.query);

				if (code == 0) {
					this.dataInfo = data;
				}
			},
			//经销商库存
			async getWMSReportStockForCustomer(e = {}) {
				let {
					code,
					data
				} = await GetWMSReportStockForCustomer(this.query);

				if (code == 0) {
					this.dataInfo2 = data;
				}
			},
			async getStockPivotTableByCost() {
				let {
					code,
					data
				} = await StockPivotTableByCost({
					CusGrade: 1,
					CusName: this.query.CusName
				});
				if (code == 0) {
					this.tableData3 = data.data;
				}
			},
			//库存透视数据
			async getStockPivotTable() {
				let params = {};
				params = Object.assign({}, params, this.query, this.query2);
				let {
					code,
					data
				} = await GetStockPivotTable(params);

				if (code == 0) {
					this.tableData = data.data;
					this.total = data.Count;
				}
			}, //库存透视数据
			async getStockPivotTableDetail(e) {
				let params = {};
				params.CusGrade = 1;
				params = Object.assign({}, params, e);
				let {
					code,
					data
				} = await GetStockPivotTableDetail(params);

				if (code == 0) {
					this.tableData2 = data;
				}
			}, // L3商业销量趋势图
			async getWMSReportCustomerStockTendency(e = {}) {
				let params = {};
				params.IsQuarter = this.yearIndex;
				params.CusGrade = this.sjIndex + 1;
				params = Object.assign({}, params, e, this.query3);

				let {
					code,
					data
				} = await GetWMSReportCustomerStockTendency(params);

				if (code == 0) {
					this.dataInfo3 = data;
				}
			},
			//新模式平台库存
			async getOrgConsignmentStock() {
				let {
					code,
					data
				} = await GetOrgConsignmentStock(this.query4);

				if (code == 0) {
					this.tableData4 = data.data;
					this.total4 = data.Count;
				}
			},
			//新模式平台库存-详情
			async getOrgConsignmentStockDetail(e) {
				let {
					code,
					data
				} = await GetOrgConsignmentStockDetail(e);

				if (code == 0) {
					this.tableData5 = data.data;
				}
			},
			handleCurrentChange(e) {
				this.query2.pageIndex = e;
				this.getStockPivotTable();
			},
			handleSizeChange(e) {
				this.query2.pageSize = e;
				this.getStockPivotTable();
			},
			handleCurrentChange4(e) {
				this.query4.pageIndex = e;
				this.getOrgConsignmentStock();
			},
			handleSizeChange4(e) {
				this.query4.pageSize = e;
				this.getOrgConsignmentStock();
			},
			handReset(e = '') {
				if (e == '2') {
					this.FromArr2.map((item, index) => {
						item.modelvalue = '';
					})
					this.query3 = {};
					this.getWMSReportCustomerStockTendency();
				} else {
					this.FromArr.map((item, index) => {
						item.modelvalue = '';
					})
					this.query = {};
					this.query2 = {
						CusGrade: 1,
						pageSize: 10,
						pageIndex: 1,
					};
					this.tableData2 = [];
					this.getWMSReportStockForOrganization();
					this.getWMSReportStockForCustomer();
					this.getStockPivotTable();
				}
			},
			handSearch(e = '') {
				if (e == '2') {
					this.query3.LEVEL1 = this.FromArr2[0].modelvalue;
					this.query3.LEVEL3 = this.FromArr2[1].modelvalue ? this.FromArr2[1].modelvalue.join(',') : '';
					this.query3.CusName = this.FromArr2[2].modelvalue;
					this.getWMSReportCustomerStockTendency();
				} else {
					this.query.LEVEL1 = this.FromArr[0].modelvalue;
					this.query.LEVEL3 = this.FromArr[1].modelvalue ? this.FromArr[1].modelvalue.join(',') : '';
					this.query.CusName = this.FromArr[2].modelvalue;
					this.getWMSReportStockForOrganization();
					this.getWMSReportStockForCustomer();
					this.getStockPivotTable();
					this.getStockPivotTableByCost();
				}
			},
			switchChange(e, k) {
				this[k + 'Index'] = e;
				this.getWMSReportCustomerStockTendency();
			}
		}
	}
</script>

<style lang="less" scoped>
	.channel-stock {
		padding-bottom: 200px;

		.view-row {
			display: flex;
		}

		.view-search {
			height: 88px;
			margin: 16px 0px 16px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			border-bottom: 1px solid #E5E5E5;

			.search-title {
				font-size: 16px;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #1D2129;
				position: absolute;
				top: 16px;
				left: 16px;
			}

			.row-item {
				transition: all .5s;
			}

			.view-switch {
				border-radius: 2px;
				overflow: hidden;
				display: flex;
				cursor: pointer;
				position: absolute;
				top: 16px;
				right: 16px;

				.switch-item {
					width: 54px;
					height: 28px;
					line-height: 28px;
					text-align: center;
					background: #FFFFFF;
					box-sizing: border-box;
					border: 1px solid #E5E6EB;
					font-size: 14px;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 400;
					color: #4E5969;
				}

				.switch-item:first-child {
					border-radius: 2px 0px 0px 2px;
					border-right: 0px;
				}

				.switch-item:last-child {
					border-radius: 0px 2px 2px 0px;
					border-left: 0px;
				}

				.current {
					border: 1px solid #BF0030;
					background: #BF0030;
					color: #FFFFFF;
				}

				.current2 {
					border: 1px solid #00266D;
					background: #00266D;
					color: #FFFFFF;
				}
			}


			.btngroup {
				float: none;
				//margin-left: 24px;
				margin-top: 0px;
			}
		}

		.view-switch-list {
			display: flex;
			align-items: center;
			justify-content: center;

			.view-switch {
				overflow: hidden;
				display: flex;
				cursor: pointer;

				.switch-item-red {
					width: 80px;
					height: 32px;
					line-height: 32px;
					text-align: center;
					box-sizing: border-box;
					font-size: 14px;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 400;
					color: #E71D43;
					background: url('../../../../assets/report/btn-red.png') no-repeat;
					background-size: 100% 100%;
					margin: 0px 8px;
				}

				.switch-item-blue {
					width: 80px;
					height: 32px;
					line-height: 32px;
					text-align: center;
					box-sizing: border-box;
					font-size: 14px;
					font-family: PingFang SC-Medium, PingFang SC;
					font-weight: 400;
					color: #00266D;
					background: url('../../../../assets/report/btn-blue.png') no-repeat;
					background-size: 100% 100%;
					margin: 0px 8px;
				}

				.current-red {
					background: url('../../../../assets/report/btn-red-checked.png') no-repeat;
					background-size: 100% 100%;
					color: #FFFFFF;
				}

				.current-blue {
					background: url('../../../../assets/report/btn-blue-checked.png') no-repeat;
					background-size: 100% 100%;
					color: #FFFFFF;
				}
			}
		}

		.merge {
			min-height: 88px;
			padding-bottom: 22px;
			position: relative;
			margin-bottom: 0px;
			align-items: flex-end;
		}

		.content-view {
			background: #FFFFFF;
			margin-top: 16rpx;
			position: relative;
		}
	}

	.view-amount {
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		padding: 12px;


		.amount-label {
			font-size: 16px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #333333;
		}

		.amount-value {
			font-size: 32px;
			font-family: D-DIN-Bold, D-DIN;
			font-weight: 700;
			line-height: 40px;
			letter-spacing: 5px;
			//text-shadow: 0px 2px 8px rgba(27, 126, 242, 0.32);
			background: linear-gradient(180deg, rgba(27, 126, 242, 0.48) 0%, #1B7EF2 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			margin: 0px 10px;
		}

		.amount-unit {
			font-size: 14px;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			color: #999999;
		}
	}
</style>